import { render } from "./pestel_matrices_attractiveness.vue?vue&type=template&id=bdf7ff5a&scoped=true"
import script from "./pestel_matrices_attractiveness.vue?vue&type=script&lang=js"
export * from "./pestel_matrices_attractiveness.vue?vue&type=script&lang=js"

import "./pestel_matrices_attractiveness.vue?vue&type=style&index=0&id=bdf7ff5a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf7ff5a"]])

export default __exports__